import { render, staticRenderFns } from "./ShipperAddPage.vue?vue&type=template&id=ac1a4bfc&"
import script from "./ShipperAddPage.vue?vue&type=script&lang=js&"
export * from "./ShipperAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports